export default __webpack_public_path__ + "static/media/sliderFlip_noThemeSelected.b81e9e01.svg";